import getApiClient from '@/plugins/api-client'

export default {
    loadSettings() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('settings')
            .then(result => {
                self.settings = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
    goToEditSetting(settingId) {
        this.$router.push({
            name: 'Alterar configuração',
            params: {
                id: settingId
            }
        })
    }
}
